import { gql } from "@apollo/client";

export const GET_SHIFT_LOCATIONS = gql`
  query GetShiftLocations($shiftId: bigint) {
    Shift_Gaurd(where: { ShiftId: { _eq: $shiftId } }) {
      IoLocLocations(order_by: { DateTime: asc }) {
        Latitude
        Longitude
        DateTime
        Floor
      }
      Id
      Gaurd {
        GaurdFirstName
      }
    }
  }
`;

export const GET_SHIFTS_AFTER_DATE = gql`
  query GetShiftsAfterDate($buildingId: uuid, $_gte: timestamptz) {
    Shift(
      where: {
        buildingId: { _eq: $buildingId }
        _and: { StartDateTime: { _gte: $_gte } }
      }
      order_by: { StartDateTime: asc }
    ) {
      Id
      Description
    }
  }
`;

export const GET_SHIFTS = gql`
  query GetShifts($buildingId: uuid, $limit: Int = 10, $offset: Int = 10) {
    Shift_aggregate(where: { Building: { Id: { _eq: $buildingId } } }) {
      aggregate {
        count
      }
    }
    Shift(
      where: { Building: { Id: { _eq: $buildingId } } }
      order_by: { StartDateTime: desc }
      offset: $offset
      limit: $limit
    ) {
      Description
      StartDateTime
      EndDateTime
      Shift_Gaurds {
        Gaurd {
          GaurdFirstName
        }
      }
      Id
    }
  }
`;
